import { createContext } from 'react'

import { WorkdayJobsFilterPropsObjectString } from './WorkdayJobsFilter/WorkdayJobsFilterProps'

type WorkdayJobsContextType = {
  openDropdown?: string
  tempSelections: WorkdayJobsFilterPropsObjectString
  filters: WorkdayJobsFilterPropsObjectString
  toggleDropdown: (param: string) => void
  resetFilters: () => void
  removeFilter: (category: string, itemToRemove: string) => void
  hidelocation?: string
  hidejobtype?: string
  hidetypeofcontract?: string
  hideexperience?: string
  hidejobfunction?: string
  hidebusinessunit?: string
  hideproductgroup?: string
  filteredJobscount?: number
}

const defaultContext: WorkdayJobsContextType = {
  openDropdown: '',
  filters: {},
  tempSelections: {},
  hidelocation: '',
  hidejobtype: '',
  hidetypeofcontract: '',
  hideexperience: '',
  hidejobfunction: '',
  hidebusinessunit: '',
  hideproductgroup: '',
  filteredJobscount: 0,
  toggleDropdown: () => {},
  resetFilters: () => {},
  removeFilter: () => {},
}

export const WorkdayJobsContext = createContext(defaultContext)
